import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import EvolutionBroadcastsAPI from '../../api/evolutionBroadcasts';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getBroadcasts($state) {
    return [...$state.records].sort((a, b) => b.id - a.id);
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isFetching: true });
    try {
      const { data } = await EvolutionBroadcastsAPI.get();
      commit(types.SET_EVOLUTION_BROADCASTS, data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, payload) => {
    commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isCreating: true });
    try {
      const { data } = await EvolutionBroadcastsAPI.create(payload);
      commit(types.ADD_EVOLUTION_BROADCAST, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...payload }) => {
    commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await EvolutionBroadcastsAPI.update(id, payload);
      commit(types.EDIT_EVOLUTION_BROADCAST, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isDeleting: true });
    try {
      await EvolutionBroadcastsAPI.delete(id);
      commit(types.DELETE_EVOLUTION_BROADCAST, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EVOLUTION_BROADCAST_UI_FLAG, { isDeleting: false });
    }
  },
  activate: async ({ commit }, id) => {
    const { data } = await EvolutionBroadcastsAPI.activate(id);
    commit(types.EDIT_EVOLUTION_BROADCAST, data);
  },
  pause: async ({ commit }, id) => {
    const { data } = await EvolutionBroadcastsAPI.pause(id);
    commit(types.EDIT_EVOLUTION_BROADCAST, data);
  },
};

export const mutations = {
  [types.SET_EVOLUTION_BROADCAST_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_EVOLUTION_BROADCAST]: MutationHelpers.create,
  [types.SET_EVOLUTION_BROADCASTS]: MutationHelpers.set,
  [types.EDIT_EVOLUTION_BROADCAST]: MutationHelpers.update,
  [types.DELETE_EVOLUTION_BROADCAST]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
